import { env } from "@repo/env";

export const livekitConfig = {
  get serverUrl() {
    return env.LIVEKIT_URL ?? "";
  },
  get apiKey() {
    return env.LIVEKIT_API_KEY ?? "";
  },
  get apiSecret() {
    return env.LIVEKIT_API_SECRET ?? "";
  },
};

// Validate configuration on startup
export const validateLiveKitConfig = () => {
  const missing: string[] = [];

  if (!livekitConfig.serverUrl) {
    missing.push("LIVEKIT_URL");
  }
  if (!livekitConfig.apiKey) {
    missing.push("LIVEKIT_API_KEY");
  }
  if (!livekitConfig.apiSecret) {
    missing.push("LIVEKIT_API_SECRET");
  }

  if (missing.length > 0) {
    console.error(
      "❌ Missing LiveKit environment variables:",
      missing.join(", "),
    );
    console.error("Please set these in your .env file or Infisical");
  }

  return missing.length === 0;
};
